import { COLOURS } from 'resources'

const FailedExternalSurveyStyles = {
  Modal: `
    && {
      max-width: 550px;
    }
    .modal-content {
      padding: 50px 30px;
      box-shadow: 2px 2px 5px ${COLOURS.blackShadow2};
      border-radius: 15px;
    }
    .modal-header {
      border-bottom: none;
    }
  `,
  ModalHeader: `
    justify-content: center;
    padding: 10px;
    .modal-title {
      font-weight: 600;
      font-size: 26px;
      text-align: center;
    }
  `,
  ModalBody: `
    text-align: center;
    font-size: 18px;
    padding: 10px;
  `,
  ModalFooter: `
    padding: 10px 0 0;
    border: 0px;
    justify-content: center;
  `,
  Button: `
    font-weight: bold;
    font-weight: bold;
    background-color: ${COLOURS.hollywoodCerise};
    border-color: ${COLOURS.hollywoodCerise};
    width: auto;
    border-radius: 100px;
    padding: 10px 30px;
    height: 50px;
    transition: all 0.3s;
    :active, :focus, :hover {
      opacity: 0.7;
    }
  `,
}

export default FailedExternalSurveyStyles
